import { useEffect } from 'react';

const useClinicScopeRefresh = (refreshFn) => {
  useEffect(() => {
    if (typeof refreshFn !== 'function') return undefined;
    const handler = () => refreshFn();
    window.addEventListener('clinic-scope-changed', handler);
    return () => window.removeEventListener('clinic-scope-changed', handler);
  }, [refreshFn]);
};

export default useClinicScopeRefresh;
